import React, { useContext, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
// import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import { SpinnerContext } from '../../context/spinnerContext'
import { yupResolver } from '@hookform/resolvers/yup'
import DropzoneController from '../dropzone'
import { acceptExtensions } from '../../helper/function'
import { addPhotosschema } from '../../util/validationSchema'
import { IMAGE_MODULE } from '../../util/constant'
import { useDispatch, useSelector } from 'react-redux'
import { addExtraPhotos, getAllcleaningReportsCategory } from '../../redux/slices/cleanersSlice'
import { errorToast, successToast } from '../../util/Toast/toast'

const AddPhotosForm = ({ toggleAddPhotoModal, setIsRefresh, cleaning_id }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const { cleaningReportsCategory } = useSelector(({ cleaners }) => cleaners)

  const {
    handleSubmit,
    control,
    watch,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(addPhotosschema),
    defaultValues: {}
  })

  useEffect(() => {
    dispatch(getAllcleaningReportsCategory())
  }, [])

  const onSubmit = (data) => {
    const payload = {
      id: cleaning_id,
      data: {
        images: data?.images?.map((url) => ({
          s3Url: url,
          meta: {} // Add metadata if needed
        })),
        cleaning_reports_category_id: data?.cleaning_reports_category_id?.cleaning_reports_category_id
      }
    }

    setIsRefresh(false)
    changeLoader(true)
    dispatch(addExtraPhotos(payload)).then(({ payload, error }) => {
      if (payload?.status === 200) {
        successToast(payload?.data?.status_message || 'Success!')
        setIsRefresh(true)
        changeLoader(false)
        toggleAddPhotoModal()
        reset()
      } else {
        errorToast(payload?.data?.status_message || error?.message)
        changeLoader(false)
      }
    })
  }

  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <div className="form-group input_text border-remove">
              <label>
                Type<span className="text-danger"> *</span>
              </label>
              <Controller
                name="cleaning_reports_category_id"
                control={control}
                render={({ field }) => (
                  <>
                    <Select
                      {...field}
                      className={`react-selectcomponent form-control select-box-filed ${errors?.cleaning_reports_category_id ? 'error-input' : ''}`}
                      getOptionLabel={(option) => `${option?.category}`}
                      getOptionValue={(option) => `${option?.cleaning_reports_category_id}`}
                      options={
                        cleaningReportsCategory || [
                          { label: 'Clean Place', value: 'clean_place' },
                          { label: 'Broken Object', value: 'broken_object' },
                          { label: 'Deep Clean', value: 'deep_clean' }
                        ]
                      }
                      isClearable
                      isSearchable={true}
                      placeholder={`Select Type`}
                      classNamePrefix="select_kanakku"
                      defaultValue={''}
                    />
                    <small>{errors?.cleaning_reports_category_id?.message}</small>
                  </>
                )}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-lg-12 col-sm-12">
            <div className="form-group">
              <label>Upload Photos <span className="text-danger"> *</span></label>
              <DropzoneController
                name="images"
                maxFiles={10}
                acceptExtensions={acceptExtensions}
                control={control}
                files={watch('images') || []}
                module={IMAGE_MODULE.CLEANING_REPORTS}
                isEditImage={true}
                isAddMode={true}
              />
                <small>{errors?.images?.message}</small>
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => toggleAddPhotoModal()}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary common-field-btn w-100">
              {`Save`}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default AddPhotosForm
